import { render, staticRenderFns } from "./AnagraficaList.vue?vue&type=template&id=4b7dc78d&scoped=true&"
import script from "./AnagraficaList.vue?vue&type=script&lang=ts&"
export * from "./AnagraficaList.vue?vue&type=script&lang=ts&"
import style0 from "./AnagraficaList.vue?vue&type=style&index=0&id=4b7dc78d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7dc78d",
  null
  
)

export default component.exports